import React, { useContext } from "react";

import { AmortizationContext } from "../AmortizationProvider";
import { dollarsTo2Places, percentTo3Places } from "../helpers";

const styles = require("./styles.module.scss");

const AmortizationInputs = () => {
  const {
    amortization: { loan_info, escrow_info },
  } = useContext(AmortizationContext);

  return (
    <div className={styles.container}>
      <table>
        <tbody>
          <tr>
            <td>Loan amount</td>
            <td>{dollarsTo2Places(loan_info.starting_loan_amount)}</td>
          </tr>
          <tr>
            <td>Rate</td>
            <td>{percentTo3Places(loan_info.rate)}</td>
          </tr>
          <tr>
            <td>Term in months</td>
            <td>{loan_info.term_in_months}</td>
          </tr>
          <tr>
            <td>Monthly P&I</td>
            <td>{dollarsTo2Places(loan_info.monthly_p_and_i)}</td>
          </tr>
        </tbody>
      </table>
      <table>
        <tbody>
          <tr>
            <td>Escrow starting balance</td>
            <td>{dollarsTo2Places(escrow_info.starting_balance)}</td>
          </tr>
          <tr>
            <td>Monthly escrowed taxes</td>
            <td>{dollarsTo2Places(escrow_info.monthly_tax_payment)}</td>
          </tr>
          <tr>
            <td>Monthly escrowed insurance</td>
            <td>{dollarsTo2Places(escrow_info.monthly_insurance_payment)}</td>
          </tr>
        </tbody>
      </table>
    </div>
  );
};

export default AmortizationInputs;
